import rtrim from './rtrim';
import ltrim from './ltrim';
export default function trim(str, chars) {
    return rtrim(ltrim(str, chars), chars);
}
//# sourceMappingURL=trim.js.map